import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'

const OrderDeclinedAlert = () => {
  const { t } = useTranslation(['Clients'])

  return (
    <KibTopLevelAlert
      heading={t('Clients:TIMELINE.PRESCRIPTION_CARD.ALERT_ORDER_DECLINED')}
      severity="error"
    />
  )
}

export default OrderDeclinedAlert
